import React from 'react'
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import Banner from "../assets/banner.mp4";
import HighlightText from '../components/core/HomePage/HighlightText';
import Footer from '../components/common/Footer';

const Home = () => {
  return (
    <div>
      {/* Section 1 */}
      <div className="relative mx-auto flex w-11/12 max-w-maxContent flex-col items-center justify-between gap-8 text-white">
        {/* Become a Certified Expert */}
        <Link to={"/"}>
          <div className="group mx-auto mt-16 w-fit rounded-full bg-richblue-800 p-1 font-bold text-richblue-300 drop-shadow-[0_1.5px_rgba(255,255,255,0.25)] transition-all duration-200 hover:scale-95 hover:drop-shadow-none">
            <Link to={"/courses/sre-foundation"}>
            <div className="flex flex-row items-center gap-2 rounded-full px-10 py-[5px] transition-all duration-200 text-white group-hover:bg-richblue-900">
              <p>Become a Certified Expert</p>
              <FaArrowRight />
            </div>
            
            </Link>
          </div>
        </Link>

        {/* Heading */}
        <div className="text-center text-4xl font-semibold" style={{ color: "#073B4C" }}>
          Empower Your Expertise with
          <HighlightText text={"Our Certifications"} />
        </div>

        {/* Sub Heading */}
        <div className="-mt-3 w-[90%] text-center text-lg font-bold text-richblue-400">
          With our professional training and certification programs, you can
          gain experience while learning from highly qualified and certified
          trainers through interactive sessions for ITIL 4, SRE, PMP, PRINCE2®,
          Cloud, GenAI, and more.
        </div>

        {/* Video */}
        <div className="mx-3 my-7 shadow-[10px_-5px_50px_-5px] shadow-blue-200">
          <video
            className="shadow-[20px_20px_rgba(255,255,255)]"
            muted
            loop
            autoPlay
          >
            <source src={Banner} type="video/mp4" />
          </video>
        </div>



        
      </div>
      <Footer/>
    </div>

  );
}

export default Home